import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import cn from 'classnames';
import { useTranslate, useHTMLSafeTranslate } from '@awardit/react-use-translate';
import { Wrapper, Breadcrumbs } from '@crossroads/ui-components';
import { getInputFilters } from '@crossroads/shop-state/filter';
import { useHistory } from 'react-router';
import styles from 'shop-views/ProductListHero.scss';

var prepareImageSources = _ref => {
  var small = _ref.small,
      medium = _ref.medium,
      large = _ref.large;
  var images = [{
    media: medium || large ? "(max-width: 550px)" : "",
    srcSet: small ? `${small.x1}, ${small.x2} 2x` : ""
  }, {
    media: large ? "(max-width: 1057px)" : "",
    srcSet: medium ? `${medium.x1}, ${medium.x2} 2x` : ""
  }, {
    media: "",
    srcSet: large ? `${large.x1}, ${large.x2} 2x` : ""
  }].filter(img => img.srcSet);
  return images;
};

var Delimeter = () => /*#__PURE__*/React.createElement("span", {
  className: styles.delimeter
}, "/");

var useHeroTitleParts = fallback => {
  var _useHistory = useHistory(),
      location = _useHistory.location;

  var filters = getInputFilters(location).reduce((a, c) => {
    var code = c.code.split(":")[0];

    if (code === "manufacturer") {
      a[code] = c.value;
    }

    if (code === "points") {
      a[code] = `${typeof c.minValue === "number" ? c.minValue : ""}` + "-" + `${typeof c.maxValue === "number" ? c.maxValue : ""}`;
    }

    return a;
  }, {});
  return _extends({}, filters, {
    fallback
  });
};

var ProductListHero = _ref2 => {
  var title = _ref2.title,
      subTitle = _ref2.subTitle,
      description = _ref2.description,
      totalCount = _ref2.totalCount,
      images = _ref2.images,
      className = _ref2.className,
      breadcrumbLinks = _ref2.breadcrumbLinks,
      breadcrumbCurrent = _ref2.breadcrumbCurrent,
      _ref2$isShort = _ref2.isShort,
      isShort = _ref2$isShort === void 0 ? false : _ref2$isShort,
      _ref2$hasTitleParts = _ref2.hasTitleParts,
      hasTitleParts = _ref2$hasTitleParts === void 0 ? false : _ref2$hasTitleParts;
  var t = useTranslate();
  var safeTranslate = useHTMLSafeTranslate();

  var _ref3 = images || {},
      smallImage = _ref3.small,
      mediumImage = _ref3.medium,
      largeImage = _ref3.large;

  var gotImage = smallImage || mediumImage || largeImage || false;
  var imageSources = images ? prepareImageSources(images) : [];
  var titleParts = useHeroTitleParts(title);
  var translationTitle = hasTitleParts && titleParts.manufacturer ? titleParts.manufacturer : titleParts.fallback;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.productListHero, className, {
      [styles.gotImage]: gotImage
    }, {
      [styles.short]: isShort
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.innerBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.imageContainer
  }, gotImage && /*#__PURE__*/React.createElement("picture", {
    key: `${title}_heroimage`,
    className: styles.image,
    alt: `Logo ${title}`
  }, imageSources.map(_ref4 => {
    var srcSet = _ref4.srcSet,
        media = _ref4.media;
    return /*#__PURE__*/React.createElement("source", {
      key: srcSet,
      srcSet: srcSet,
      media: media
    });
  }), /*#__PURE__*/React.createElement("img", {
    src: (smallImage == null ? void 0 : smallImage.x1) || (mediumImage == null ? void 0 : mediumImage.x1) || (largeImage == null ? void 0 : largeImage.x1) || "",
    alt: `Logo ${title}`
  }))), /*#__PURE__*/React.createElement(Wrapper, {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(Breadcrumbs, {
    className: styles.breadcrumbs,
    links: breadcrumbLinks,
    Delimeter: Delimeter,
    current: breadcrumbCurrent
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, title && /*#__PURE__*/React.createElement("h1", {
    className: styles.title
  }, title), subTitle && /*#__PURE__*/React.createElement("h2", {
    className: styles.subTitle
  }, subTitle), /*#__PURE__*/React.createElement("div", {
    className: cn({
      [styles.titleParts]: hasTitleParts
    })
  }, totalCount < 1 && /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: t("PRODUCTLIST_HERO.TITLE_PREFIX_EMPTY")
    },
    className: styles.totalCount
  }), totalCount === 1 && /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: safeTranslate("PRODUCTLIST_HERO.TITLE_PREFIX_SINGULAR", {
      title: translationTitle
    }),
    className: styles.totalCount
  }), totalCount > 1 && /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: safeTranslate("PRODUCTLIST_HERO.TITLE_PREFIX_PLURAL", {
      itemsCount: totalCount.toString(),
      title: translationTitle
    }),
    className: styles.totalCount
  }), hasTitleParts && titleParts.points && /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: safeTranslate("PRODUCTLIST_HERO.IN_PRICERANGE", {
      points: titleParts.points.toString()
    }),
    className: styles.titlePartsPoints
  })), description && /*#__PURE__*/React.createElement("p", {
    className: styles.description
  }, description))))));
};
var ProductListHeroHint = _ref5 => {
  var title = _ref5.title,
      loadingText = _ref5.loadingText,
      className = _ref5.className,
      breadcrumbLinks = _ref5.breadcrumbLinks,
      breadcrumbCurrent = _ref5.breadcrumbCurrent;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.productListHero, className)
  }, /*#__PURE__*/React.createElement(Wrapper, {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(Breadcrumbs, {
    className: styles.breadcrumbs,
    links: breadcrumbLinks,
    Delimeter: Delimeter,
    current: breadcrumbCurrent
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, title && /*#__PURE__*/React.createElement("h1", {
    className: styles.title
  }, title), loadingText && /*#__PURE__*/React.createElement("p", {
    className: styles.loadingText
  }, loadingText, "\xA0", /*#__PURE__*/React.createElement("span", null, title)))), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  })));
};

export { ProductListHero, ProductListHeroHint };
//# sourceMappingURL=index.js.map
